"use client";

import { Link } from "react-router-dom";

const posts = [
  {
    category: "Architecture",
    post: (
      <>
        Quantity Surveying Consultant
        <br />
        Hong Kong
      </>
    ),
  },
  {
    category: "Architecture",
    post: (
      <>
        Design Lead - Architecture
        <br />
        Hong Kong
      </>
    ),
  },
  {
    category: "Art",
    post: (
      <>
        3D & Metaverse Artist
        <br />
        Hong Kong
      </>
    ),
  },
  {
    category: "Information Technology",
    post: (
      <>
        Software Engineer
        <br />
        Hong Kong
      </>
    ),
  },
  {
    category: "Product Design",
    post: (
      <>
        Healthcare Product Designer
        <br />
        Shenzhen
      </>
    ),
  },
  {
    category: "Trading",
    post: (
      <>
        Project Manager, Organic Food
        <br />
        Shenzhen
      </>
    ),
  },
  {
    category: "Marketing & Communications",
    post: (
      <>
        Communications Manager
        <br />
        Shenzhen
      </>
    ),
  },
];

function CareersPage(props: { yScroll?: number }) {
  return (
    <div className="full-screen py-24 px-2 md:px-[10%]">
      <div className="container mx-auto">
        <div className="text-2xl text-black font-medium mb-4">CAREERS</div>
        <div className="mt-4">
          Search our current opportunities around the world.
        </div>
        <div className="w-full mt-8 [&>tr]:border-0">
          {posts.map((post, index) => (
            <div
              className="grid gap-2 grid-cols-1 md:grid-cols-3 p-2"
              key={`post-${index}`}
            >
              <div className="font-bold">{post.category}</div>
              <div>{post.post}</div>
              <div>
                <Link to={"mailto:hr@tonsofminds.com"}>Apply</Link>
              </div>
              <hr className="w-full md:col-span-3" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CareersPage;
